import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Input from "../../../../../../components/forms-fields/Input";
import { addSafeguarding } from "../../../../../../schemas";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ADMIN_AUTH_TOKEN, BASE_URL, POST_CARE_PLAN_URL, UPLOAD_MEMORY_BOX_FILE, ADMIN_ID } from "../../../../../../env";
import ReactDOMServer from 'react-dom/server';
import {
  postRecords,
  catchAsync,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
} from "../../../../../../helper/helper";
import CustomSelect from "../../../../../../components/forms-fields/CustomSelectStaffMembers";
import TextArea from "../../../../../../components/forms-fields/TextArea";
import moment from "moment";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import Layout from "../../../../../../components/layouts/Layout";
import AddHealthIssues from "../../../../../health-issue/AddHealthIssues";
import HealthCategories from "../../../../../health-issue/HealthCategories";
function AddSafeguarding() {
  const storedUserDetails = localStorage.getItem("profileUserDetails");
  const userDetails = JSON.parse(storedUserDetails);
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [isToastAddCarePlans, setIsToastAddCarePlans] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [parentSubCatValidationStatus, setParentSubCatValidationStatus] = useState(false);




  // File Upload
  const [uploadedFilePath, setUploadedFilePath] = useState("");
  const [videoSizeError, setVideoSizeError] = useState(false)

  const handleImageChange = async (e) => {
    setIsSubmitButtonClicked(true);
    try {
      const file = e.target.files[0];
      const fileType = file.type;
      const fileSize = file.size;
      

      // Validate file size (5MB = 1,048,576 bytes)
      if (fileSize > 5 * 1024 * 1024) {
        alert('File size exceeds 5MB');
        setVideoSizeError(true); // Consider renaming this to something like setFileSizeError
        setIsSubmitButtonClicked(false);
        return;
      }

      // Validate file type (only images, PDFs, and document files)
      if (
        fileType === 'image/jpeg' ||
        fileType === 'image/png' ||
        fileType === 'image/jpg' ||
        fileType === 'application/pdf' ||
        fileType === 'application/msword' ||
        fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || // docx
        fileType === 'application/vnd.ms-excel' ||
        fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // xlsx
      ) {
        const fileData = new FormData();
        fileData.append('file', file);

        const apiResponse = await fetch(UPLOAD_MEMORY_BOX_FILE, {
          method: "POST",
          body: fileData,
          headers: {
            Authorization: `Bearer ${ADMIN_AUTH_TOKEN}`,
          },
        });

        const resultResponse = await apiResponse.json();
        setUploadedFilePath(resultResponse?.data);
        
      } else {
        // Unsupported file format
        alert('Unsupported file format');
      }
      setIsSubmitButtonClicked(false);
    } catch (error) {
      console.error("Error uploading file:", error);
      setIsSubmitButtonClicked(false);
    }
  };

  // Form submission
  const [suFormData, setSuFormData] = useState({
    addedby: ADMIN_ID,
    concernsAboutServiceUser: "",
    voiceOfTheServiceUser: "",
    areThereAnyImmediateRisks: "",
    whatActionDoYouFeel: "",
    comments: "",
    fullDetailOfConcern: "",
    yourName: "",
    yourNameDslDdsl: "",
    originOfConcern: "",
    uploadedFilePath: uploadedFilePath,
    anyWitnesses: "",
    actionTaken: "",
    dateTimeReporting: moment().valueOf(),
    category: selectedCategoryId,
    subcategory: selectedCategoryId,
    eventDateTime: moment().valueOf(),
  });


  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    setValues,
  } = useFormik({
    initialValues: suFormData,
    validationSchema: addSafeguarding,
    onSubmit: async (values) => {
      try {
        setIsSubmitButtonClicked(true);
        await postAddCarePlansFormData(values);
      } catch (error) {
        
      }
    },
  });

  const processPostRecords = (method, data) => {
    if (data?.status !== isSuccess) {
      setIsToastAddCarePlans(true);
      toastErrorMessages(toast.error, data?.message, "", 10, 10);
      setIsSubmitButtonClicked(false);

    } else if (
      method === "postAddCarePlansFormData" &&
      data?.status === isSuccess
    ) {
      setIsToastAddCarePlans(true);
      toastSuccessMessages(toast.success, data?.message, "/care-plan/general-notes", 10, 10);
      setIsSubmitButtonClicked(false);
    }
  };

  const postAddCarePlansFormData = catchAsync(async (req, res) => {
    const noteDetailsString = ReactDOMServer.renderToString(htmlData);
    const updateValues = {
      userId: userDetails?._id,
      addedby: ADMIN_ID,
      noteType: "Safeguarding",
      isHTML: true,
      title: values?.areThereAnyImmediateRisks,
      flag: false,
      noteDetails: noteDetailsString,
      category: values?.category,
      // subcategory: selectedCategoryId,
      healthNote: values?.concernsAboutServiceUser,
      complaint: values?.areThereAnyImmediateRisks,
      eventDateTime: moment(values.eventDateTime).valueOf(),
    }

    
    
    const response = await postRecords(POST_CARE_PLAN_URL, updateValues);
    
    setIsSubmitButtonClicked(false);
    processPostRecords("postAddCarePlansFormData", response);
  });


  const handleInputChangePrevFields = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
    handleChange(e);
    handleBlur(e);
  };

  const [htmlData, setHtmlData] = useState("");

  useEffect(() => {
    let fileUploadContent;

    if (uploadedFilePath !== "") {
      if (uploadedFilePath.match(/\.(jpeg|jpg|png)$/i)) {
        fileUploadContent = (
          <a href={`${BASE_URL}${uploadedFilePath}`} target="_blank" rel="noopener noreferrer">
            <img
              src={`${BASE_URL}${uploadedFilePath}`}
              alt="Memory Box"
              style={{ cursor: "pointer" }}
            />
          </a>
        );
      } else {
        fileUploadContent = (
          <a href={`${BASE_URL}${uploadedFilePath}`} target="_blank" rel="noopener noreferrer">
            Click to view
          </a>
        );
      }
    } else {
      fileUploadContent = null;
    }

    setHtmlData(
      <>
        <div className="col-md-12">
          <p><strong>File Upload: </strong>
            <span id="uploadedFilePathData">{fileUploadContent}</span>
          </p>
        </div>

        <div className="col-md-12">
          <p><strong>Concerns about the service user: </strong><span id="concernsAboutServiceUserData">{values?.concernsAboutServiceUser}</span></p>
        </div>

        <div className="col-md-12">
          <p><strong>Voice of the service user: </strong><span id="voiceOfTheServiceUserData">{values?.voiceOfTheServiceUser}</span></p>
        </div>

        <div className="col-md-12">
          <p><strong>Are there any immediate risks: </strong><span id="areThereAnyImmediateRisksData">{values?.areThereAnyImmediateRisks}</span></p>
        </div>

        <div className="col-md-12">
          <p><strong>What action do you feel should be taken?: </strong><span id="whatActionDoYouFeelData">{values?.whatActionDoYouFeel}</span></p>
        </div>

        <div className="col-md-12">
          <p><strong>Comments: </strong><span id="commentsData">{values?.comments}</span></p>
        </div>

        <div className="col-md-4">
          <p><strong>Your Name: </strong><span id="yourNameData">{values?.yourName}</span></p>
        </div>

        <div className="col-md-4">
          <p><strong>Origin of concern: </strong><span id="originOfConcernData">{values?.originOfConcern}</span></p>
        </div>

        <div className="col-md-12">
          <p><strong>Full detail of concern: </strong><span id="fullDetailOfConcernData">{values?.fullDetailOfConcern}</span></p>
        </div>

        <div className="col-md-4">
          <p><strong>Any witnesses: </strong><span id="anyWitnessesData">{values?.anyWitnesses}</span></p>
        </div>

        <div className="col-md-4">
          <p><strong>Date and time of reporting</strong>
            <span id="dateTimeReportingData">{moment(values?.dateTimeReporting).format("DD/MM/YYYY / hh:mm:ss A")}</span></p>
        </div>

        <div className="col-md-6">
          <p>To be completed by DSL/DDSL<br /><strong>Your Name: </strong><span id="yourNameDslDdslData">{values?.yourNameDslDdsl}</span></p>
        </div>

        <div className="col-md-6">
          <p><br /><strong>Action taken: </strong><span id="actionTakenData">{values?.actionTaken}</span></p>
        </div>
      </>
    );
  }, [values, uploadedFilePath]);





  const handleBodyPartSelect = async (catId) => {
    setSelectedCategoryId(catId);

    setSuFormData((prevFormData) => ({
      ...prevFormData,
      category: catId,
    }));
  };


  const handleSubCatValidationStatus = (status) => {
    
    setParentSubCatValidationStatus(status);
  };

  useEffect(() => {
    
  }, [parentSubCatValidationStatus]);

  useEffect(() => {
    setFieldValue("category", selectedCategoryId);
    if (!parentSubCatValidationStatus) {
      setFieldValue("subcategory", "no-child");
    }
    else {
      setFieldValue("subcategory", "");
    }
  }, [selectedCategoryId, parentSubCatValidationStatus]);
  

  const [receivedSubCategory, setReceivedSubCategory] = useState(null);
  

  const handleSubCategoryChange = (subCategoryValue) => {
    setReceivedSubCategory(subCategoryValue);
    setFieldValue("category", subCategoryValue?.value);
    setFieldValue("subcategory", subCategoryValue?.value);
    setFieldTouched("subcategory", false); // Mark subcategory as touched
    // Other handling logic if needed
  };



  return (
    <>
      <Layout pageTitleText="Notes">
        <div className="incidents consentCapacityAddNew">
          <div className="mainContent ">
            <div className="mainContentText">
              <h3>Add Safeguarding note</h3>
              <form onSubmit={handleSubmit}>
                <div className="formBlockContent">
                  <div className="row">


                    <div className="col-md-6">
                      <Input
                        type="datetime-local"
                        id="eventDateTime"
                        name="eventDateTime"
                        value={moment(values?.eventDateTime).format('YYYY-MM-DDTHH:mm')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText="Date and time of disclosure/findings"
                        customError={touched?.eventDateTime && errors?.eventDateTime}
                        errorMessage={errors?.eventDateTime}
                        erroClass={
                          touched?.eventDateTime && errors?.eventDateTime
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />

                    </div>
                    <div className="col-md-6"></div>
                    <div className="col-md-6">

                      <TextArea
                        id="concernsAboutServiceUser"
                        name="concernsAboutServiceUser"
                        value={values?.concernsAboutServiceUser}
                        onChange={handleInputChangePrevFields}
                        onBlur={handleBlur}
                        labelText="Concerns about the service user"
                        rows="3"
                        className="mb-0"
                        customError={touched?.concernsAboutServiceUser && errors?.concernsAboutServiceUser}
                        errorMessage={errors?.concernsAboutServiceUser}
                        erroClass={
                          touched?.concernsAboutServiceUser && errors?.concernsAboutServiceUser
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>

                    <div className="col-md-6">

                      <TextArea
                        id="voiceOfTheServiceUser"
                        name="voiceOfTheServiceUser"
                        value={values?.voiceOfTheServiceUser}
                        onChange={handleInputChangePrevFields}
                        onBlur={handleBlur}
                        labelText="Voice of the service user"
                        rows="3"
                        className="mb-0"
                        customError={touched?.voiceOfTheServiceUser && errors?.voiceOfTheServiceUser}
                        errorMessage={errors?.voiceOfTheServiceUser}
                        erroClass={
                          touched?.voiceOfTheServiceUser && errors?.voiceOfTheServiceUser
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>

                    <div className="col-md-6">

                      <TextArea
                        id="areThereAnyImmediateRisks"
                        name="areThereAnyImmediateRisks"
                        value={values?.areThereAnyImmediateRisks}
                        onChange={handleInputChangePrevFields}
                        onBlur={handleBlur}
                        labelText="Are there any immediate risks"
                        rows="3"
                        className="mb-0"
                        customError={touched?.areThereAnyImmediateRisks && errors?.areThereAnyImmediateRisks}
                        errorMessage={errors?.areThereAnyImmediateRisks}
                        erroClass={
                          touched?.areThereAnyImmediateRisks && errors?.areThereAnyImmediateRisks
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>

                    <div className="col-md-6">

                      <TextArea
                        id="whatActionDoYouFeel"
                        name="whatActionDoYouFeel"
                        value={values?.whatActionDoYouFeel}
                        onChange={handleInputChangePrevFields}
                        onBlur={handleBlur}
                        labelText="What action do you feel should be taken?"
                        rows="3"
                        className="mb-0"
                        customError={touched?.whatActionDoYouFeel && errors?.whatActionDoYouFeel}
                        errorMessage={errors?.whatActionDoYouFeel}
                        erroClass={
                          touched?.whatActionDoYouFeel && errors?.whatActionDoYouFeel
                            ? "validationError"
                            : ""
                        }
                      />
                    </div>

                    <div className="col-md-12">

                      <TextArea
                        id="comments"
                        name="comments"
                        value={values?.comments}
                        onChange={handleInputChangePrevFields}
                        onBlur={handleBlur}
                        labelText="Comments"
                        rows="3"
                        className="mb-0"
                        customError={touched?.comments && errors?.comments}
                        errorMessage={errors?.comments}
                        erroClass={
                          touched?.comments && errors?.comments
                            ? "validationError"
                            : ""
                        }
                      />
                    </div>

                    <div className="col-md-6">
                      <Input
                        type="text"
                        id="originOfConcern"
                        name="originOfConcern"
                        value={values?.originOfConcern}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText="Origin of concern"
                        customError={touched?.originOfConcern && errors?.originOfConcern}
                        errorMessage={errors?.originOfConcern}
                        erroClass={
                          touched?.originOfConcern && errors?.originOfConcern
                            ? "validationError"
                            : ""
                        }
                      />
                    </div>
                    <div className="col-md-6"></div>
                    <div className="col-sm-12 col-md-6">
                      <div className="memoryBoxContent">
                        <div className="imageBox text-center">
                          <label htmlFor="profilePicture" className="upload-icon">
                            <div className="avatarAction">
                              {uploadedFilePath !== '' && (
                                <>
                                  {uploadedFilePath.match(/\.(jpeg|jpg|png)$/i) ? (
                                    <img
                                      src={`${BASE_URL}${uploadedFilePath}`}
                                      alt="Memory Box"
                                      style={{ cursor: "pointer" }}
                                    />
                                  ) : (
                                    <a
                                      href={`${BASE_URL}${uploadedFilePath}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
                                    >
                                      Click to view
                                    </a>
                                  )}
                                </>
                              )}
                            </div>
                          </label>
                        </div>
                      </div>
                      <div className="form-group">
                        <input
                          name="fileName"
                          id="fileName"
                          type="file"
                          accept="image/*, .pdf, .doc, .docx, .xls, .xlsx"
                          onChange={handleImageChange}
                        />
                        {
                          videoSizeError ? ( // Consider renaming this to fileSizeError
                            <>
                              <div className="validationError">
                                <div className="text-danger">Error: File size exceeds the 5MB limit. Please upload a smaller file.</div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div><p><small>Please upload a file that is 5MB or smaller.</small></p></div>
                            </>
                          )
                        }
                      </div>
                    </div>

                    <div className="col-md-12">

                      <TextArea
                        id="fullDetailOfConcern"
                        name="fullDetailOfConcern"
                        value={values?.fullDetailOfConcern}
                        onChange={handleInputChangePrevFields}
                        onBlur={handleBlur}
                        labelText="Full details of concern"
                        rows="3"
                        className="mb-0"
                        customError={touched?.fullDetailOfConcern && errors?.fullDetailOfConcern}
                        errorMessage={errors?.fullDetailOfConcern}
                        erroClass={
                          touched?.fullDetailOfConcern && errors?.fullDetailOfConcern
                            ? "validationError"
                            : ""
                        }
                      />
                    </div>
                    <div className="col-md-12">
                      <HealthCategories
                        name="category"
                        onSelect={handleBodyPartSelect}
                        onSelectSubCat={handleSubCategoryChange}
                        selectedSubCategory={receivedSubCategory}
                        selectedCategoryId={selectedCategoryId}
                        value={values?.category}
                        filterBy={""}
                        label="Incident Location"
                        sublabel="Select Subcategory"
                        subCatValidationStatus={parentSubCatValidationStatus}
                        setSubCatValidationStatus={handleSubCatValidationStatus}
                        erroClassCategory={touched.category && errors.category ? "validationError" : ""}
                        customErrorCategory={touched.category && errors.category}
                        errorMessageCategory={touched.category && errors.category ? errors.category : ""}
                        customErrorSubcategory={touched.subcategory && errors.subcategory}
                        errorMessageSubcategory={touched.subcategory && errors.subcategory ? errors.subcategory : ""}
                        erroClassSubcategory={touched.subcategory && errors.subcategory ? "validationError" : ""}

                      />
                    </div>

                    <div className="col-md-4">
                      <Input
                        type="text"
                        id="yourName"
                        name="yourName"
                        value={values?.yourName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText="Your Name"
                        customError={touched?.yourName && errors?.yourName}
                        errorMessage={errors?.yourName}
                        erroClass={
                          touched?.yourName && errors?.yourName
                            ? "validationError"
                            : ""
                        }
                      />

                    </div>

                    <div className="col-md-4">
                      <Input
                        type="text"
                        id="anyWitnesses"
                        name="anyWitnesses"
                        value={values?.anyWitnesses}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText="Any witnesses"
                        customError={touched?.anyWitnesses && errors?.anyWitnesses}
                        errorMessage={errors?.anyWitnesses}
                        erroClass={
                          touched?.anyWitnesses && errors?.anyWitnesses
                            ? "validationError"
                            : ""
                        }
                      />

                    </div>

                    <div className="col-md-4">
                      <Input
                        type="datetime-local"
                        id="dateTimeReporting"
                        name="dateTimeReporting"
                        value={moment(values?.dateTimeReporting).format('YYYY-MM-DDTHH:mm')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText="Date and time of reporting"
                        customError={touched?.dateTimeReporting && errors?.dateTimeReporting}
                        errorMessage={errors?.dateTimeReporting}
                        erroClass={
                          touched?.dateTimeReporting && errors?.dateTimeReporting
                            ? "validationError"
                            : ""
                        }
                      />
                    </div>
                  </div>
                  <div className="greyBackground">
                    <div className="row">
                      <div className="col-md-12">
                        <p>To be completed by DSL/DDSL</p>
                      </div>

                      <div className="col-md-6">
                        <Input
                          type="text"
                          id="yourNameDslDdsl"
                          name="yourNameDslDdsl"
                          value={values?.yourNameDslDdsl}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          labelText="Your Name"
                          customError={touched?.yourNameDslDdsl && errors?.yourNameDslDdsl}
                          errorMessage={errors?.yourNameDslDdsl}
                          erroClass={
                            touched?.yourNameDslDdsl && errors?.yourNameDslDdsl
                              ? "validationError"
                              : ""
                          }
                        />

                      </div>

                      <div className="col-md-6">
                        <Input
                          type="text"
                          id="actionTaken"
                          name="actionTaken"
                          value={values?.actionTaken}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          labelText="Action taken"
                          customError={touched?.actionTaken && errors?.actionTaken}
                          errorMessage={errors?.actionTaken}
                          erroClass={
                            touched?.actionTaken && errors?.actionTaken
                              ? "validationError"
                              : ""
                          }
                        />

                      </div>

                    </div>
                  </div>
                </div>

                <div className="formActionButtons">
                  <Link
                    to={"/care-plan/general-notes"}
                    className="btn btn-sm btn-outline-primary"
                  >
                    Back
                  </Link>

                  {isSubmitButtonClicked ? (
                    <Button
                      // onClick={subModalAddCarePlans}
                      className="btn-sm"
                      variant="primary"
                      disabled
                    >
                      Loading...
                    </Button>
                  ) : (
                    <Button className="btn-sm" variant="primary" type="submit">
                      Submit
                    </Button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
      {isToastAddCarePlans && <ToastContainer />}
    </>
  );
}


export default AddSafeguarding